import { generateNewTokenApi, sendOtpApi, verifyOtpApi } from '@api/auth';
import { getCitiesApi, getLoungesApi } from '@api/lounge';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { EnterPhoneFormInputs, LoginState, VerifyOtpForm } from '@utils/types';
import Cookies from 'js-cookie';

export const sendOtp = createAsyncThunk(
  'sendOtp',
  async (loginPayload: EnterPhoneFormInputs) => {
    await sendOtpApi({
      phoneNo: parseInt(loginPayload.phoneNumber),
    });
    return loginPayload.phoneNumber;
  },
);

export const verifyOtp = createAsyncThunk(
  'optVerification',
  async (otpPayload: VerifyOtpForm) => {
    const token = await verifyOtpApi({
      phoneNo: parseInt(otpPayload.phoneNo),
      otp: parseInt(otpPayload.otp),
      captchaToken: otpPayload?.captchaToken as string,
      ...(otpPayload.loungeId ? { loungeId: otpPayload.loungeId } : {}),
    });

    return { token, loungeId: otpPayload.loungeId };
  },
);

export const getCities = createAsyncThunk('getCities', async () => {
  const cities = await getCitiesApi();
  return cities;
});

export const getLounges = createAsyncThunk(
  'getLounges',
  async (city: string) => {
    const lounges = await getLoungesApi(city);
    return lounges;
  },
);

export const generateNewToken = createAsyncThunk(
  'generateNewToken',
  async (loungeId: string) => {
    const token = await generateNewTokenApi(loungeId);
    return token;
  },
);

const initialState: LoginState = {
  step: 1,
  phoneNumber: '',
  token: '',
  error: '',
  cities: [],
  lounges: [],
  loungeId: '',
  loungeName: '',
  selectedCity: '',
};

export const loginSlice = createSlice({
  name: 'login',
  initialState,
  reducers: {
    setStep: (state, action: PayloadAction<number>) => {
      state.step = action.payload;
    },
    resetStep: (state) => {
      Cookies.remove('ca_token');
      state.step = 1;
      state.phoneNumber = '';
      state.token = '';
      state.cities = [];
      state.lounges = [];
      state.loungeId = '';
      state.error = '';
    },
    setLoungeName: (state, action: PayloadAction<string>) => {
      state.loungeName = action.payload;
    },
    setSelectedCity: (state, action: PayloadAction<string>) => {
      state.selectedCity = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(sendOtp.fulfilled, (state, action) => {
      if (action.payload) {
        state.phoneNumber = action.payload;
        state.step = 2;
      }
    });
    builder.addCase(verifyOtp.fulfilled, (state, action) => {
      if (action.payload.token) {
        Cookies.set('ca_token', action.payload.token);
        state.token = action.payload.token;
        state.step = action.payload.loungeId ? 4 : 3;
        state.loungeId = action.payload.loungeId || '';
      }
    });
    builder.addCase(getCities.fulfilled, (state, action) => {
      state.cities = action.payload;
    });
    builder.addCase(getLounges.fulfilled, (state, action) => {
      state.lounges = action.payload;
      // state.step = 4;
    });
    builder.addCase(generateNewToken.fulfilled, (state, action) => {
      if (action.payload) {
        Cookies.set('ca_token', action.payload);
        state.token = action.payload;
        state.step = 4;
      }
    });
  },
});

// Action creators are generated for each case reducer function
export const { setStep, resetStep, setLoungeName, setSelectedCity } =
  loginSlice.actions;

export default loginSlice.reducer;
